/* eslint-disable no-param-reassign,no-restricted-globals */
import store from '../store';
import { capitalizeFirstLetter } from './strings';
import { getLocalStorageItem } from '@/util/local-storage';
import getApiEndpoint from '@/util/get-api-endpoint';

const isAdmin = () => {
  if (store.getters['auth/currentUser']) {
    return store.getters['auth/currentUser'].role === 'admin';
  }
  return false;
};

const isUser = () => {
  if (store.getters['auth/currentUser']) {
    return store.getters['auth/currentUser'].role === 'user';
  }
  return false;
};

const isImpeccableReputationInstitutionEmployee = () => {
  if (store.getters['auth/currentUser']) {
    return store.getters['auth/currentUser'].role === 'impeccable_reputation_institution_employee';
  }
  return false;
};

const isPrintTerminal = () => {
  if (getLocalStorageItem('this_device_is_print_terminal') === 'true') {
    return true;
  }
  return false;
};

export const helpers = {
  $isPrintTerminal: isPrintTerminal,
  $isAdmin: isAdmin,
  $isUser: isUser,
  $isImpeccableReputationInstitutionEmployee: isImpeccableReputationInstitutionEmployee,

  $isSubjectAdmin() {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].role === 'subject_admin';
    }
    return false;
  },

  $isLTOUAdmin() {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].role === 'ltou_admin';
    }
    return false;
  },

  $isLTOUEmployee() {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].role === 'ltou_employee';
    }
    return false;
  },

  $isExplorer() {
    const ua = window.navigator.userAgent;
    const msie = ua.indexOf('Trident');

    return msie > -1;
  },

  $hasPermission(permissions) {
    if (isAdmin() || !permissions?.length) {
      return true;
    }
    let isAllowed = false;
    if (permissions && store.getters['auth/permissions']) {
      for (let i = 0; i < permissions.length; i++) {
        if (store.getters['auth/permissions'][permissions[i]]) {
          isAllowed = true;
          break;
        }
      }
    }
    return isAllowed;
  },

  $hasCorrectRole(roles) {
    if (isAdmin() || !roles?.length) {
      return true;
    }
    let isAllowed = false;
    if (roles && store.getters['auth/currentUser']) {
      for (let i = 0; i < roles.length; i++) {
        if (store.getters['auth/currentUser'].role === roles[i]) {
          isAllowed = true;
          break;
        }
      }
    }
    return isAllowed;
  },

  $isCurrentUser(id) {
    if (store.getters['auth/currentUser']) {
      return store.getters['auth/currentUser'].id === id;
    }
    return false;
  },

  $capitalizeFirstLetter(s) {
    return capitalizeFirstLetter(s);
  },

  $backendUrl(path) {
    return getApiEndpoint() + path;
  },

  $frontendUrl(path) {
    return import.meta.env.VITE_APP_PUBLIC_PATH + path;
  },

  $previewBackendUrl(path) {
    return `${this.$backendUrl(path)}page_preview_key=${import.meta.env.VITE_APP_PAGE_PREVIEW_KEY}`;
  },

  $getProperty(object, propertyName) {
    const parts = propertyName.split('.');
    let property = object || this;

    for (let i = 0; i < parts.length; i += 1) {
      if (property) {
        property = property[parts[i]];
      }
    }
    return property;
  },

  $canPreviewFile(extension) {
    const supportedExtensions = ['png', 'jpeg', 'jpg', 'gif', 'bmp'];
    if (
      !/(iPad|iPhone|iPod|Trident|Android)/g.test(navigator.userAgent) &&
      !/(Apple)/g.test(navigator.vendor)
    ) {
      // not an iOS browser, not Android browser, not Safari, not IE
      supportedExtensions.push('pdf');
    }
    return supportedExtensions.includes(extension?.trim().toLowerCase());
  },

  $permitHasRule(permit, rule) {
    if (!Array.isArray(permit.rules) || permit.rules.length === 0) {
      return false
    }
    
    return permit.rules.some(record => record.rule === rule)
  }
};

function registerHelpers(Vue) {
  Object.keys(helpers).forEach((helper) => {
    Vue.prototype[helper] = helpers[helper];
  });
}

export default registerHelpers;
